import { useLayoutEffect, useRef } from "react";

export function useToastEscape() {
  const dismissToastsRef = useRef<(() => boolean) | null>(null);
  useLayoutEffect(() => {
    const dismissOnEscape = (event: KeyboardEvent) => {
      if (
        event.key !== "Escape" ||
        event.defaultPrevented ||
        event.isComposing ||
        !dismissToastsRef.current?.()
      )
        return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    // Register before page handlers' passive effects, including on initial page mount.
    window.addEventListener("keydown", dismissOnEscape, true);
    return () => window.removeEventListener("keydown", dismissOnEscape, true);
  }, []);
  return dismissToastsRef;
}
